/* 孫吳傳・赤壁篇（第 12～14 章）：赤壁與烏林（208 年）
 * 長江由西往東橫過地圖。北岸是烏林，曹軍的營落沿岸排開，江邊的戰船首尾相接；南岸是赤壁，吳軍的船隊從這裡出發。
 * 三條列傳的赤壁章節共用這張圖（不是 5v5 的赤壁地圖）。 */
export const SHORE_N = 1450, CHAIN_Y = 1680, CHAIN = [1800, 7400], LINE_Y = 2350, SOUTH_Y = 3950;
export default {
  id: 'chibi', name: '赤壁', W: 9200, H: 5400, seed: 2080,
  bases: [[4600, 4700], [4600, 800]], // 赤壁（吳軍）、烏林（曹營）
  rivers: [{ pts: [[-100, 2720], [3000, 2680], [6000, 2740], [9300, 2700]], hw: 1250, fords: [] }],
  roads: [
    { pts: [[800, 900], [2500, 800], [4600, 800], [6800, 850], [8600, 700]], w: 140 }, // 北岸的營道
    { pts: [[4600, 900], [4300, 400]], w: 100 }, // 往北的華容道
    { pts: [[2800, 4700], [4600, 4700], [6400, 4650]], w: 130 }, // 南岸
  ],
  rocks: [[1200, 4700, 420, 220], [7900, 4800, 420, 200], [8500, 1100, 360, 180]],
  woods: 0.3,
  sight: 0.8,
  clearings: [[4600, 800, 900], [2500, 900, 600], [6800, 900, 600], [4600, 4700, 700]],
  tents: [
    { x: 2500, y: 900, n: 9, r: 520, col: '#3b5a99', flag: '曹' }, { x: 4600, y: 800, n: 12, r: 640, chief: true, col: '#3b5a99', flag: '曹' },
    { x: 6800, y: 900, n: 9, r: 520, col: '#3b5a99', flag: '曹' }, { x: 4600, y: 4700, n: 7, r: 460, chief: true, col: '#b8433a', flag: '周' },
  ],
  grass: [[3500, 1200, 220, 90], [5700, 1150, 220, 90]],
};
